import { render } from "./DataList.vue?vue&type=template&id=96c3b1b2&scoped=true"
import script from "./DataList.vue?vue&type=script&lang=js"
export * from "./DataList.vue?vue&type=script&lang=js"

import "./DataList.vue?vue&type=style&index=0&id=96c3b1b2&scoped=true&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\fe_smartphone-doi-soat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c3b1b2"]])

export default __exports__